import { HtmlService } from './html.service';

export default angular
  .module('sfMobile.services.html', [])
  .factory('htmlService', HtmlService).name;
